import { ArrowForwardIos, ContentCopy, Delete, TimerOutlined } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const InactivityHandle = ({ type, position, onConnect }) => {
    const commonStyle = {
      background: "linear-gradient(45deg, #8b5cf6, #7c3aed)",
      width: "16px",
      height: "16px",
      left: "50%",
      transform: "translateX(-50%)",
      cursor: "pointer",
      border: "2px solid #ffffff",
    };
    const posStyle = position === "top" ? { top: "-8px" } : { bottom: "-8px" };
    return (
      <Handle
        type={type}
        position={position}
        style={{ ...commonStyle, ...posStyle }}
        onConnect={onConnect}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "1px",
            marginBottom: "1px",
            pointerEvents: "none",
            transform: "rotate(90deg)",
          }}
        />
      </Handle>
    );
  };

  const storageItems = useNodeStorage();
  const inactivityMessage = data?.message || data?.text || "";
  const repeatCountRaw = Number(data?.retryLimit);
  const repeatCount = Number.isFinite(repeatCountRaw) && repeatCountRaw > 0
    ? repeatCountRaw
    : Array.isArray(data?.intervals) && data.intervals.length > 0
      ? data.intervals.length
      : 1;
  const isCloseTicket = !!data?.isCloseTicket;

  return (
    <div
      style={{
        backgroundColor: isCloseTicket ? "#FEF2F2" : "#FAFBFF",
        padding: "12px",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
        border: isCloseTicket ? "1px solid rgba(239, 68, 68, 0.35)" : "1px solid rgba(139, 92, 246, 0.3)",
        width: "180px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <InactivityHandle
        type="target"
        position="top"
        onConnect={params => console.log("handle onConnect", params)}
      />
      {!isCloseTicket && (
        <InactivityHandle
          type="source"
          position="bottom"
        />
      )}

      <div
        style={{
          position: "absolute",
          right: "8px",
          top: "8px",
          display: "flex",
          gap: "4px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "14px", 
            height: "14px", 
            color: "#94a3b8",
            cursor: "pointer",
            "&:hover": { color: "#8b5cf6" }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "14px", 
            height: "14px", 
            color: "#94a3b8",
            cursor: "pointer",
            "&:hover": { color: "#ef4444" }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "8px"
        }}
      >
        <TimerOutlined
          sx={{
            width: "16px",
            height: "16px",
            marginRight: "6px",
            color: isCloseTicket ? "#ef4444" : "#8b5cf6"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "14px",
          fontWeight: "600"
        }}>
          {data?.isCloseTicket ? "Fechamento" : "Inatividade"}
        </div>
      </div>

      <div style={{ 
        color: "#374151", 
        fontSize: "12px",
        lineHeight: "1.4",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: "6px",
        backgroundColor: isCloseTicket ? "#FEE2E2" : "#f5f3ff",
        borderRadius: "4px",
        border: isCloseTicket ? "1px solid #FECACA" : "1px solid #ddd6fe",
        marginBottom: "8px"
      }}>
        {inactivityMessage}
      </div>

      {!isCloseTicket && (
        <div style={{
          color: "#5b21b6",
          fontSize: "12px",
          fontWeight: "500",
          padding: "6px",
          backgroundColor: "#ede9fe",
          borderRadius: "4px",
          border: "1px solid #ddd6fe"
        }}>
          Repetir {repeatCount} vezes
        </div>
      )}

    </div>
  );
});
